module.exports = __webpack_public_path__ + "img/PIE_CHART.f2f1882c.svg";